import React from 'react';

// Generated from the LegalApp design canvas.
export default function SpotComplainant({ style }) {
  style = { ...{  }, ...style };
  return (
    <svg className="lp-spot-iso" viewBox="-124.6 -137.0 270.3 261.0" role="img" aria-label="Illustration: a phone asking when, where and who in Hindi, beside a complaint form being filled in" style={style}>
    <polygon points="107.4,62.0 17.3,114.0 17.3,106.0 107.4,54.0" fill="#C2D4F6" />
    <polygon points="-90.1,52.0 17.3,114.0 17.3,106.0 -90.1,44.0" fill="#E1EAFB" />
    <polygon points="0.0,-8.0 107.4,54.0 17.3,106.0 -90.1,44.0" fill="#FFFFFF" />
    <polygon points="90.1,58.0 84.9,61.0 84.9,-13.0 90.1,-16.0" fill="#BCD1F8" />
    <polygon points="31.2,30.0 84.9,61.0 84.9,-13.0 31.2,-44.0" fill="#E4EDFD" />
    <polygon points="36.4,-47.0 90.1,-16.0 84.9,-13.0 31.2,-44.0" fill="#FFFFFF" />
    <polygon points="38.1,-26.0 64.1,-11.0 64.1,-17.0 38.1,-32.0" fill="#0B1B3F" />
    <polygon points="38.1,-10.0 45.0,-6.0 45.0,-14.0 38.1,-18.0" fill="#2563DE" />
    <polygon points="49.4,-5.5 77.1,10.5 77.1,6.5 49.4,-9.5" fill="#BCD1F8" />
    <polygon points="38.1,3.0 45.0,7.0 45.0,-1.0 38.1,-5.0" fill="#2563DE" />
    <polygon points="49.4,7.5 70.1,19.5 70.1,15.5 49.4,3.5" fill="#BCD1F8" />
    <polygon points="38.1,16.0 45.0,20.0 45.0,12.0 38.1,8.0" fill="#F2A33A" />
    <polygon points="49.4,20.5 77.1,36.5 77.1,32.5 49.4,16.5" fill="#FFE2B8" />
    <polygon points="38.1,29.0 45.0,33.0 45.0,25.0 38.1,21.0" fill="#F2A33A" />
    <polygon points="49.4,33.5 70.1,45.5 70.1,41.5 49.4,29.5" fill="#FFE2B8" />
    <polygon points="-8.7,35.0 -48.5,58.0 -48.5,-28.0 -8.7,-51.0" fill="#0B1B3F" />
    <polygon points="-58.9,52.0 -48.5,58.0 -48.5,-28.0 -58.9,-34.0" fill="#16284D" />
    <polygon points="-19.1,-57.0 -8.7,-51.0 -48.5,-28.0 -58.9,-34.0" fill="#2A3D69" />
    <polygon points="-12.1,29.0 -45.0,48.0 -45.0,-23.0 -12.1,-42.0" fill="#EAF1FE" />
    <polygon points="-24.2,-18.0 -43.3,-7.0 -43.3,-13.0 -24.2,-24.0" fill="#F2A33A" />
    <polygon points="-14.7,-12.5 -35.5,-0.5 -35.5,-6.5 -14.7,-18.5" fill="#2563DE" />
    <polygon points="-20.8,2.0 -43.3,15.0 -43.3,9.0 -20.8,-4.0" fill="#F2A33A" />
    <polygon points="-15.6,21.0 -41.6,36.0 -41.6,23.0 -15.6,8.0" fill="#FFFFFF" />
    <polygon points="-17.3,17.0 -19.9,18.5 -19.9,15.5 -17.3,14.0" fill="#F2A33A" />
    <g className="lp-iso-bubble lp-float-a">
      <rect x="-114.6" y="-110.0" width="56" height="36" rx="12" fill="#FFFFFF" />
      <path d="M-100.6 -75.0 l-2 11 l12 -11 z" fill="#FFFFFF" />
      <text x="-86.6" y="-86.0" className="lp-iso-q" fill="#0B1B3F">
        {"कब?"}
      </text>
    </g>
    <g className="lp-iso-bubble lp-float-b">
      <rect x="-12.9" y="-127.0" width="64" height="36" rx="12" fill="#FFFFFF" />
      <path d="M1.1 -92.0 l-2 11 l12 -11 z" fill="#FFFFFF" />
      <text x="19.1" y="-103.0" className="lp-iso-q" fill="#0B1B3F">
        {"कहाँ?"}
      </text>
    </g>
    <g className="lp-iso-bubble lp-float-a">
      <rect x="61.7" y="-69.0" width="74" height="36" rx="12" fill="#FFFFFF" />
      <path d="M75.7 -34.0 l-2 11 l12 -11 z" fill="#FFFFFF" />
      <text x="98.7" y="-45.0" className="lp-iso-q" fill="#0B1B3F">
        {"किसने?"}
      </text>
    </g>
    </svg>
  );
}
